module.exports = __webpack_public_path__ + "img/choose-up-dejun.d0baf344.png";